<template lang="pug">
  //- @mouseover.prevent.stop="focus"
  //- @mouseleave.prevent.stop="leave"
  a.preview-image(
    href="#"
    :class="{ maximized }"
    @click.prevent.stop
  )
    //- gehört in .preview-image
    //- v-touch:tap="($event) => $emit('maximize', { event: $event, media })"
    .observer
      lazy-component(@show="show")
        img(:src="image.src")
    figure.image(
      :style="style"
    )
      img(
        :src="image.src"
        :class="{ loaded }"
      )
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'PreviewImage',
    data: () => ({
        loaded: false
    }),
    props: {
        media: {
            type: Object,
            required: true
        },
        product: {
            type: Object,
            required: true
        },
        preferredWidth: {
            type: Number
        },
        aspectRatio: {
            type: Number
        },
        maximized: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        w() {
            let width = this.media.image.width;
            // NOTE: check for retina and other high dpi screens
            if (this.preferredWidth) {
                width = Math.min(this.preferredWidth, width);
            }
            return width;
        },
        h() {
            let height;
            if (this.aspectRatio) height = this.w / this.aspectRatio;
            else height = this.w / (this.media.image.width / this.media.image.height);
            return height;
        },
        style() {
            return {
                width: `${this.w}px`,
                height: `${this.h}px`,
                'background-image': `url(${this.image.blurry})`
            };
        },
        image() {
            let image = this.media.image;

            let root = '';
            const endpoint = `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}`;
            if (process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE) root = process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE;
            const base = endpoint + root + 'images/';

            let format = '';
            if (this.webpSupport) format = '&format=webp';

            let w = this.w;
            let h = this.h;
            if (window.devicePixelRatio) {
                w = Math.min(w * window.devicePixelRatio, this.media.image.width);
                h = Math.min(h * window.devicePixelRatio, this.media.image.height);
            }

            return {
                src: `${base}${image.id}/${image.name}?fit&w=${w}&h=${h}${format}`,
                error: `${base}${image.id}/${image.name}?fit&w=${w}&h=${h}&preview=greyscale`,
                blurry: `${base}${image.id}/${image.name}?fit&w=${w}&h=${h}&preview=blur`
            };
        },
        ...mapGetters({
            webpSupport: 'webpSupport'
        })
    },
    methods: {
        show() {
            this.loaded = true;
            // setTimeout(() => this.loaded = true, 600)
        },
        focus() {
            // this.setFocusedMedia({ product: this.product, media: this.media });
        },
        leave() {
            // this.removeFocusedMedia();
        }
        // ...mapMutations({
        //   setFocusedMedia: 'shop/setFocusedMedia',
        //   removeFocusedMedia: 'shop/removeFocusedMedia'
        // })
    }
};
</script>

<style lang="sass" scoped>
.observer
  display: absolute
  width: 0
  height: 0
  left: -300vw
a.preview-image
  &:hover,
  &:focus
    @apply shadow-lg
  &.maximized
    @apply shadow-lg
    // display: none
  .image
    @apply bg-gray-200 shadow rounded-sm overflow-hidden
    overflow: hidden
    background-position: center
    background-repeat: no-repeat
    background-size: cover
    transition: box-shadow .3s ease
    img
      opacity: 0
      height: 100%
      width: 100%
      object-fit: contain
      transition: opacity .3s ease
      &.loaded
        opacity: 1
</style>
